import styled, { css } from "styled-components";
import { IResponsive, BreakPoints } from "src/types/responsiveness";

export const StyledTypographyH1 = styled.span<IResponsive>`
  font-weight: 600;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 3.19rem;
          line-height: 3.28rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 3.94rem;
          line-height: 4.05rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 4.38rem;
          line-height: 4.5rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 4.38rem;
          line-height: 4.5rem;
        `;
      default:
        return css`
          font-size: 4.38rem;
          line-height: 4.5rem;
        `;
    }
  }}
`;

export const StyledTypographyH2 = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 2.43rem;
          line-height: 2.69rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 3.38rem;
          line-height: 3.74rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 3.75rem;
          line-height: 4.16rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 3.75rem;
          line-height: 4.16rem;
        `;
      default:
        return css`
          font-size: 3.75rem;
          line-height: 4.16rem;
        `;
    }
  }}
`;

export const StyledTypographyH3 = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1.88rem;
          line-height: 2.69rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 2.81rem;
          line-height: 3.74rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 3.13rem;
          line-height: 4.16rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 3.13rem;
          line-height: 4.16rem;
        `;
      default:
        return css`
          font-size: 3.13rem;
          line-height: 4.16rem;
        `;
    }
  }}
`;

export const StyledTypographyH4 = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1.63rem;
          line-height: 2.31rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 1.97rem;
          line-height: 3.74rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 2.19rem;
          line-height: 4.16rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 2.19rem;
          line-height: 4.16rem;
        `;
      default:
        return css`
          font-size: 2.19rem;
          line-height: 4.16rem;
        `;
    }
  }}
`;

export const StyledTypographyH5 = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1.25rem;
          line-height: 1.75;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 1.13rem;
          line-height: 1.58rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1.25rem;
          line-height: 1.75rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1.25rem;
          line-height: 1.75rem;
        `;
      default:
        return css`
          font-size: 1.25rem;
          line-height: 1.75rem;
        `;
    }
  }}
`;

export const StyledTypographyCardTitle = styled(StyledTypographyH5)`
  font-weight: 700;
`;

export const StyledTypographyCardDesc = styled.span<IResponsive>`
  font-weight: 400;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.88rem;
          line-height: 1.38rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.79rem;
          line-height: 1.24rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 0.88em;
          line-height: 1.38rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 0.88em;
          line-height: 1.38rem;
        `;
      default:
        return css`
          font-size: 0.88em;
          line-height: 1.38rem;
        `;
    }
  }}
`;

export const StyledTypographyBody = styled.span<IResponsive>`
  font-weight: 400;
  &.white {
    color: white;
  }

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1rem;
          line-height: 1.75rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.79rem;
          line-height: 1.58rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 0.88em;
          line-height: 1.75rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 0.88em;
          line-height: 1.75rem;
        `;
      default:
        return css`
          font-size: 0.88em;
          line-height: 1.75rem;
        `;
    }
  }}
`;

export const StyledTypographyButtonTitle = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1rem;
          line-height: 1.5rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.9rem;
          line-height: 1.35rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
      default:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
    }
  }}
`;

export const StyledTypographyHeaderItem = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.72rem;
          line-height: 1.38rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.9rem;
          line-height: 1.35rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
      default:
        return css`
          font-size: 1em;
          line-height: 1.5rem;
        `;
    }
  }}
`;

export const StyledTypographyHeaderSubItem = styled.span<IResponsive>`
  font-weight: 600;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.72rem;
          line-height: 0.99rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.9rem;
          line-height: 1.22rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1em;
          line-height: 1.38rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1em;
          line-height: 1.38rem;
        `;
      default:
        return css`
          font-size: 1em;
          line-height: 1.38rem;
        `;
    }
  }}
`;

export const StyledTypographyHeaderSubItemDesc = styled.span<IResponsive>`
  font-weight: 400;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.54rem;
          line-height: 0.81rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.68rem;
          line-height: 1.01rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 0.75rem;
          line-height: 1.13rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 0.75rem;
          line-height: 1.13rem;
        `;
      default:
        return css`
          font-size: 0.75rem;
          line-height: 1.13rem;
        `;
    }
  }}
`;

export const StyledTypographyFooterItem = styled.span<IResponsive>`
  font-weight: 600;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.63rem;
          line-height: 1.08rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.79rem;
          line-height: 1.35rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 0.88em;
          line-height: 1.5rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 0.88em;
          line-height: 1.5rem;
        `;
      default:
        return css`
          font-size: 0.88em;
          line-height: 1.5rem;
        `;
    }
  }}
`;

export const StyledTypographyBlockChainCardTitle = styled.span<IResponsive>`
  font-weight: 700;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 1.35rem;
          line-height: 2.99rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 1.69rem;
          line-height: 3.74rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1.88em;
          line-height: 4.16rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1.88em;
          line-height: 4.16rem;
        `;
      default:
        return css`
          font-size: 1.88em;
          line-height: 4.16rem;
        `;
    }
  }}
`;

export const StyledTypographyStosTitle = styled(StyledTypographyH3)`
  font-weight: 700;
`;

export const StyledTypographyStosSubTitle = styled.span<IResponsive>`
  font-weight: 600;

  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 0.72rem;
          line-height: 1.26rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 0.9rem;
          line-height: 1.58rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 1em;
          line-height: 1.75rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 1em;
          line-height: 1.75rem;
        `;
      default:
        return css`
          font-size: 1em;
          line-height: 1.75rem;
        `;
    }
  }}
`;

export const StyledTypographyStakingTitle = styled(StyledTypographyH5)`
  font-weight: 700;
`;

export const StyledTypographyStakingDesc = styled(StyledTypographyCardDesc)`
  font-weight: 400;
`;

export const StyledTypographyUseCaseTitle = styled(StyledTypographyH2)`
  font-weight: 700;
`;

export const StyledTypographyUseCaseHighTitle = styled(StyledTypographyH2)`
  font-weight: 700;
  ${({ $viewName }) => {
    switch ($viewName) {
      case BreakPoints.isMobile:
        return css`
          font-size: 2.7rem;
          line-height: 3.08rem;
        `;
      case BreakPoints.isMd:
        return css`
          font-size: 3.38rem;
          line-height: 3.85rem;
        `;
      case BreakPoints.isLg:
        return css`
          font-size: 3.75rem;
          line-height: 4.28rem;
        `;
      case BreakPoints.isXLg:
        return css`
          font-size: 3.75rem;
          line-height: 4.28rem;
        `;
      default:
        return css`
          font-size: 3.75rem;
          line-height: 4.28rem;
        `;
    }
  }}
`;

export const StyledTypographyEcosystemAppTitle = styled(
  StyledTypographyStosSubTitle,
)`
  font-weight: 600;
`;

export const StyledTypographyEcosystemSearchItem = styled(
  StyledTypographyCardDesc,
)`
  font-weight: 400;
`;

export const StyledTypographyFaqArticleTitle = styled(StyledTypographyH5)`
  font-weight: 600;
`;
